exports.cat2title = {
  accessori: {
    en: "/en/accessories",
    it: "Accessori per Macchine Lavorazione Legno",
  },
  coltello: { en: "/en/disposable-knives", it: "Coltelli Per Lavorare Legno" },
  //elettroutensili: { en: "/en/power-tools", it: "/elettroutensili" },
  frese: {
    en: "/en/router-cutters",
    it: "Frese Elicoidali per Legno ed Alluminio",
  },
  lama: { en: "/en/sawblades", it: "Lame Circolari per Legno ed Alluminio" },
  punte: { en: "/en/drill-bits", it: "Punte per Macchine Foratrici" },
  //semilavorati: { en: "/en/raw-materials", it: "/prodotti-semilavorati" },
};

exports.cat2desc = {
  accessori: {
    en: "/en/accessories",
    it: "Scopri tutti gli Accessori per Macchine Lavorazione Legno di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  coltello: {
    en: "/en/disposable-knives",
    it: "Scopri tutti i Coltelli per Lavorare Legno di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  //elettroutensili: { en: "/en/power-tools", it: "/elettroutensili" },
  frese: {
    en: "/en/router-cutters",
    it: "Scopri tutte le Frese Elicoidali per Legno ed Alluminio di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  lama: {
    en: "/en/sawblades",
    it: "Scopri tutte le Lame Circolari per Legno ed Alluminio di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  punte: {
    en: "/en/drill-bits",
    it: "Scopri tutte le Punte per Macchine Foratrici di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  //semilavorati: { en: "/en/raw-materials", it: "/prodotti-semilavorati" },
};

// sottocategoria 2 url
exports.subcat2title = {
  incisore: { en: "/scoring", it: "Lame Incisori per Circolari" },
  portatili: {
    en: "/portable-sawblade",
    it: "Lame Circolari per macchine portatili",
  },
  multilame: {
    en: "/multirippping-sawblade",
    it: "Lame Circolari per Multilama",
  },
  lamello: { en: "/brazed-cutter-joint", it: "Lame Circolari per Lamello" },
  sezionatrici: {
    en: "/panel-sizing-sawblade",
    it: "Lame Circolari Sezionatrici",
  },
  universali: { en: "/universal-sawblade", it: "Lame Circolari Universali" },

  rasanti: { en: "/square-spurs", it: "Coltelli Rasanti" },
  inserti: { en: "/disposable-inserts", it: "Inserti per Coltelli" },
  incastri: { en: "/grooving-inserts", it: "Coltelli a Incastro" },
  pialla: { en: "/planner-knives", it: "Coltelli per Pialla" },
  reversibili: { en: "/disposable-knives", it: "Coltelli Reversibili" },

  cerniere: { en: "/hinges", it: "Punte per Cerniere" },
  ciechi: { en: "/blind-holes", it: "Punte per Fori Ciechi" },
  passanti: { en: "/through-holes", it: "Punte per Fori Passanti" },
  svasatori: { en: "/countersinks", it: "Svasatori per Punte" },
  "foratrice-svasatore": {
    en: "/dowel-drills-with-countersink",
    it: "Punte Foratrici con Svasatore",
  },
  elicoidali: { en: "/twist-drill", it: "Punte Elicoidali" },

  updown: { en: "/updown", it: "Frese Elicoidali Up-Down" },
  z2: { en: "/z2", it: "Frese Elicoidali Z2" },
  z3: { en: "/z3", it: "Frese Elicoidali Z3" },
  serrature: {
    en: "/hardware-slots",
    it: "Frese Elicoidali per Scasso Serrature",
  },
  //profilare: { en: "/profiling", it: "/coltelli-a-profilare" },
  //barrette: { en: "/blank-tips", it: "/barrette" },
  //placchette: { en: "/tips-for-grooves", it: "/placchette-per-incastro" },
  //denti: { en: "/tips", it: "/denti-lama" },
  mandrini: { en: "/chucks", it: "Mandrini Portautensili" },
  pinze: { en: "/collets", it: "Pinze Elastiche di Serraggio" },
  //duro: { en: "/solid-carbide", it: "/duro" },
  //diamante: { en: "/pcd", it: "/diamante" },
};

exports.subcat2desc = {
  incisore: {
    en: "/scoring",
    it: "Scopri Lame Incisori per Circolari nella sezione Lame di International Saws. Lame Circolari con taglienti a metallo duro. Contattaci oggi!",
  },
  portatili: {
    en: "/portable-sawblade",
    it: "Scopri Lame Circolari per Macchine Portatili nella sezione Lame di International Saws. Lame Circolari con taglienti a metallo duro. Contattaci oggi!",
  },
  multilame: {
    en: "/multirippping-sawblade",
    it: "Scopri Lame Circolari per Multilama nella sezione Lame di International Saws. Lame Circolari con taglienti a metallo duro. Contattaci oggi!",
  },
  lamello: {
    en: "/brazed-cutter-joint",
    it: "Scopri Lame Circolari per Lamello nella sezione Lame di International Saws. Lame Circolari con taglienti a metallo duro. Contattaci oggi!",
  },
  sezionatrici: {
    en: "/panel-sizing-sawblade",
    it: "Scopri Lame Circolari Sezionatrici nella sezione Lame di International Saws. Lame Circolari con taglienti a metallo duro. Contattaci oggi!",
  },
  universali: {
    en: "/universal-sawblade",
    it: "Scopri Lame Circolari Universali nella sezione Lame di International Saws. Lame Circolari con taglienti a metallo duro. Contattaci oggi!",
  },
  rasanti: {
    en: "/square-spurs",
    it: "Scopri Coltelli Rasanti nella sezione Coltelli di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  inserti: {
    en: "/disposable-inserts",
    it: "Scopri Inserti per Coltelli nella sezione Coltelli di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  incastri: {
    en: "/grooving-inserts",
    it: "Scopri Coltelli a Incastro nella sezione Coltelli di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  pialla: {
    en: "/planner-knives",
    it: "Scopri Coltelli per Pialla nella sezione Coltelli di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  reversibili: {
    en: "/disposable-knives",
    it: "Scopri Coltelli Reversibili nella sezione Coltelli di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  cerniere: {
    en: "/hinges",
    it: "Scopri Punte per Cerniere nella sezione Punte per Foratrici di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  ciechi: {
    en: "/blind-holes",
    it: "Scopri Punte per Fori Ciechi nella sezione Punte per Foratrici di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  passanti: {
    en: "/through-holes",
    it: "Scopri Punte per Fori Passanti nella sezione Punte per Foratrici di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  svasatori: {
    en: "/countersinks",
    it: "Scopri Svasatori per Punte nella sezione Punte per Foratrici di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  "foratrice-svasatore": {
    en: "/dowel-drills-with-countersink",
    it: "Scopri Punte Foratrici con Svasatore nella sezione Punte per Foratrici di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  elicoidali: {
    en: "/twist-drill",
    it: "Scopri Punte Elicoidali nella sezione Punte per Foratrici di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  updown: {
    en: "/updown",
    it: "Scopri Frese Elicoidali Up-Down nella sezione Frese di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  z2: {
    en: "/z2",
    it: "Scopri Frese Elicoidali Z2 nella sezione Frese di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  z3: {
    en: "/z3",
    it: "Scopri Frese Elicoidali Z3 nella sezione Frese di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  serrature: {
    en: "/hardware-slots",
    it: "Scopri Frese Elicoidali per Scasso Serrature nella sezione Frese di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  //profilare: { en: "/profiling", it: "/coltelli-a-profilare" },
  //barrette: { en: "/blank-tips", it: "/barrette" },
  //placchette: { en: "/tips-for-grooves", it: "/placchette-per-incastro" },
  //denti: { en: "/tips", it: "/denti-lama" },
  mandrini: {
    en: "/chucks",
    it: "Scopri Mandrini Portautensili nella sezione Accessori di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  pinze: {
    en: "/collets",
    it: "Scopri Pinze Elastiche di Serraggio nella sezione Accessori di International Saws. Lunga durata anche in condizioni estreme di utilizzo. Contattaci oggi!",
  },
  //duro: { en: "/solid-carbide", it: "/duro" },
  //diamante: { en: "/pcd", it: "/diamante" },
};
